import React, { useState } from 'react'
import './Navbar.css'
import { Link, useLocation } from 'react-router-dom'

const Navbar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const location = useLocation();

    const toggleMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <>
            <div className='navbar_container'>
                <div className="navbar_left">
                    <div className="logo_image"></div>
                </div>

                <div className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <div className={`navbar_right ${isMobileMenuOpen ? 'active' : ''}`}>
                    <Link 
                        className={`navbar_icon ${location.pathname === '/' ? 'active' : ''}`} 
                        to='/'
                        onClick={() => setIsMobileMenuOpen(false)}
                    >
                        Home
                    </Link>
                    <Link 
                        className={`navbar_icon ${location.pathname === '/college' ? 'active' : ''}`} 
                        to='/college'
                        onClick={() => setIsMobileMenuOpen(false)}
                    >
                        Colleges
                    </Link>
                    <Link 
                        className={`navbar_icon ${location.pathname === '/student' ? 'active' : ''}`} 
                        to='/student'
                        onClick={() => setIsMobileMenuOpen(false)}
                    >
                        Students
                    </Link>
                    <Link 
                        className={`navbar_icon ${location.pathname === '/about' ? 'active' : ''}`} 
                        to='/about'
                        onClick={() => setIsMobileMenuOpen(false)}
                    >
                        About
                    </Link>
                    <Link 
                        className={`navbar_icon ${location.pathname === '/contact' ? 'active' : ''}`} 
                        to='/contact'
                        onClick={() => setIsMobileMenuOpen(false)}
                    >
                        Contact Us
                    </Link>

                    {/* ✅ New Register Link (External) */}
                    <a 
                        href="https://lms.mindmatrix.io/login" 
                        className="navbar_icon register_btn"
                        target="_blank" 
                        rel="noopener noreferrer"
                        onClick={() => setIsMobileMenuOpen(false)}
                    >
                        Register
                    </a>
                </div>
            </div>
        </>
    )
}

export default Navbar
